// extracted by mini-css-extract-plugin
export default {"body":"MainBody_body__dCoqD"};